<template>
    <div class="table-responsive w-100">
        <table class="table center-aligned-table">
            <thead>
                <tr>
                    <th class="border-bottom-0" >No. </th>
                    <th class="border-bottom-0"> Name </th>
                    <th class="border-bottom-0"> Quantity </th>
                    <th class="border-bottom-0"> Price </th>
                    <th class="border-bottom-0"> Total </th>
                    <th class="border-bottom-0"> </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(i, index) in cart" 
                    v-bind:key="i.itemId"
                >
                    <td> {{ index + 1 }} </td>
                    <td> {{ i.itemName }} </td>
                    <td> 
                        <a-input-number :min="1" :max="99" :value="i.quantity" @change="updateQuantity($event, i)" />
                    </td>
                    <td> {{ i.itemPrice }} </td>
                    <td> {{ total(i) }} </td>
                    <td>
                        <b-button-group>
                            <b-button variant="danger" 
                                    class="icon-btn"
                                    v-on:click="handleBtnRemoveItem(i)">
                                <i class="mdi mdi-delete-forever"></i>
                            </b-button>
                        </b-button-group>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td> Quantity : {{ totalQuantity }} </td>
                    <td></td>
                    <td> {{ totalPrice }} </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from'vuex'
export default {
    computed: {
        ...mapState({
            cart: state => state.ordersbyphonecontrol.cart.selectedItems,
            totalPrice: state => state.ordersbyphonecontrol.cart.totalPrice,
            totalQuantity : state => state.ordersbyphonecontrol.cart.totalQuantity
        }),
        
    },
    methods: {
        handleBtnRemoveItem(item) {
            this.$store.commit('ordersbyphonecontrol/removeItemFromCartState', item.itemId);
        },
        total (item) {
            return item.quantity * item.itemPrice
        },
        updateQuantity(e, i) {
        
            this.$store.commit('ordersbyphonecontrol/updateQuantityState', { 'quantity' : e, 'itemId' : i.itemId });
        }
    }
}
</script>

